import {product} from "@/utils/algorithms";
import {has, set} from "lodash";

export function buildRevertedMapping({
    arraysOfChoices = [],
    excludedMapping = {},
    value = true,
    skipFunction = () => false,
}) {
    const result = {};
    for (const path of product(...arraysOfChoices)) {
        if (!skipFunction({path, value}) && !has(excludedMapping, path)) {
            set(result, path, value);
        }
    }
    return result;
}
